/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';
import * as StoryletPropTypes from 'fera-prop-types/storylet';

export const challenge = PropTypes.shape({
  canAffordSecondChance: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  secondChanceDescription: PropTypes.string, // Branches may have no second chance
  targetNumber: PropTypes.number.isRequired,
});

export const branch = PropTypes.shape({
  actionCost: PropTypes.number.isRequired,
  challenges: PropTypes.arrayOf(challenge).isRequired,
  currencyCost: PropTypes.number.isRequired,
  currencyLocked: PropTypes.bool.isRequired,
  description: PropTypes.string, // Some branches have no description, although this is rare
  id: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  qualityLocked: PropTypes.bool.isRequired,
  qualityRequirements: PropTypes.arrayOf(StoryletPropTypes.qualityRequirement).isRequired,
});